import React from 'react';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../blur-modal';
import Text from '../text';
import ScrollableLayout from '../scrollable-layout';
import Marque from '../../app/marque';
import { CrossIcon } from '../icons';
import styles from './marque-dismissable-bar.styles';
import { KEY_CODE } from '../../../constants';

const MarqueBar = props => props.dismissed ? null : (
  <div className="marque-bar">
    <div className="row">
      <div className="small-11 columns">{props.children}</div>
      <div className="small-1 columns text-right">
        <div tabIndex={0} className="btn-close" onKeyDown={(e) => props.onDismiss(e) } onClick={() => props.onDismiss()}>
          <CrossIcon color='#999' height={25} width={25} />
        </div>
      </div>
    </div>
  </div>
)

class MarqueContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { showModal: false };
  }

  appContainer = null

  onDismiss = (e) => {
    // this.appContainer.classList.remove('has-marque-bar')
    if((e && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      this.props.dismiss()
    }
  }

  openAlertModal = () => this.setState(prevState => ({ showModal: !prevState.showModal }))

  async componentDidMount() {
    await this.props.marque.getMarqueData()
    // if (!this.appContainer)
    //   this.appContainer = document.body
    // if (!this.props.marque.loginDissmiss)
    //   this.appContainer.classList.add('has-marque-bar')
  }
  render(){
    const {
      i18n: { messages }
    } = this.props;
    return this.props.marque.loginDissmiss ? null : (
      <div className='marque-container'>
        <MarqueBar
          dismissed={this.props.marque.loginDissmiss}
          onDismiss={this.onDismiss}>
          <div className="row" >
            <span className="small-11 columns marque-message-text">
              <Text
                ellipsizeMode='tail' numberOfLines={1} style={styles.textStyle}>
                {this.props.marque.marqueData.configKeyValue}</Text>
            </span>
            <a href='javascript:;' tabIndex={0} className="small-1 columns marque-more-button" onClick={() => this.openAlertModal()}>
              <Text style={styles.touchableOpacityTextStyle}>More</Text>
            </a>
            {/* <span tabIndex={0} className="small-1 columns marque-more-button" onClick={() => this.openAlertModal()}>
              <Text style={styles.touchableOpacityTextStyle}>More</Text>
            </span> */}
          </div>
        </MarqueBar>
        <BlurModal
            visible={this.state.showModal}
            onDone={this.openAlertModal}
            headerChildren={messages['app.common.title.marque']}>
          <ScrollableLayout body={<View><Marque/></View>} />
        </BlurModal>
      </div>
    )
  }
}

export default createContainer({
  $queries: {
    marque: {
      loginDissmiss: true,
      marqueData: true,
      getMarqueData: { $call: 'getMarqueData' }
    },
    dismiss: { $call: 'marque.callLoginDissMiss' },
    i18n: {
      messages: true,
    }
  },
})(MarqueContainer);
